import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AuthserviceService } from 'src/app/service/authservice.service';
import * as xml2js from 'xml2js';

@Component({
  selector: 'app-msisdn',
  templateUrl: './msisdn.component.html',
  styleUrls: ['./msisdn.component.css']
})
export class MsisdnComponent implements OnInit {
  mobile_number: string;
  xml: string;
  strResponse: any;
  headerResponse: any
  constructor(private authService: AuthserviceService,
    private http: HttpClient,) { }

  ngOnInit(): void {
    this.fetchMSISDN();
  }
  //fetchMSISDN  this
  fetchMSISDN() {
    this.authService.fetchMobileNumber()
      .then((response) => {
        this.headerResponse = response
        console.log('success response ======================', response);

        const parser = new xml2js.Parser({ strict: false, trim: true });
        // console.log('XML =======================', this.strResponse);

        parser.parseString(response, (err, result) => {
          this.xml = result;
          if (this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0]['NS0:SERVICERESPONSE'][0]['NS0:RESPONSEHEADER'][0]['NS0:RESPONSECODE'][0] == 0) {
            this.mobile_number = this.xml['SOAP-ENV:ENVELOPE']['SOAP-ENV:BODY'][0]['NS0:SERVICERESPONSE'][0]['NS0:BODY'][0]['NS1:MSISDNRESPONSE'][0]['NS1:MSISDNHASH'][0];
            //  console.log('MSISDN ++++++++++++++++', this.mobile_number);
            localStorage.setItem('gamezklub-mobile', this.mobile_number);
            // sessionStorage.setItem('gamezklub-mobile', '12365478');


          } else {
            //switch to mobile internet msg
            console.log('success response else ======================');
          }

        });
      })
      .catch((error) => {
        this.strResponse = error;
      });

  }
}
